import { Select, Text } from "@mantine/core";

import type { FieldValueProps } from "../../types";
import { useTranslation } from "react-i18next";

interface Props extends FieldValueProps<string> {
  itemMaterials: { value: string; label: string }[];
  clearable?: boolean;
}

const MaterialTypeSelect = ({
  value,
  errors,
  onChange,
  itemMaterials,
  clearable,
}: Props) => {
  const { t } = useTranslation("forms");
  return (
    <Select
      label={
        <Text size="sm" style={{ fontWeight: "bold" }}>
          {t("forms.materialCharacteristics.labels.material")}
        </Text>
      }
      clearable={clearable}
      value={value ?? null}
      data={itemMaterials}
      placeholder={t("forms.materialCharacteristics.placeholders.material")}
      error={errors ? t("forms.materialCharacteristics.errors.material") : ""}
      onChange={material => onChange(material ?? undefined)}
    />
  );
};

export default MaterialTypeSelect;
